/**
 * @generated SignedSource<<0dc5be6a18f16997ab345a0720132580>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePaginatedMatters_matters$data = {
  readonly matters: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string | null;
      readonly node: {
        readonly creator: {
          readonly id: string | null;
          readonly name: string;
        } | null;
        readonly dueDate: string | null;
        readonly externalReference: string | null;
        readonly id: string;
        readonly insertedAt: string;
        readonly number: number;
        readonly titleText: string;
        readonly " $fragmentSpreads": FragmentRefs<"AssigneesPreview__node" | "Status__status" | "Tags_tags">;
      };
    } | null>;
    readonly total: number | null;
  } | null;
  readonly " $fragmentType": "usePaginatedMatters_matters";
};
export type usePaginatedMatters_matters$key = {
  readonly " $data"?: usePaginatedMatters_matters$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePaginatedMatters_matters">;
};
const node: ReaderFragment = function () {
  var v0 = ["matters"],
    v1 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    };
  return {
    "argumentDefinitions": [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filter"
    }, {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "limit"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "page"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sort"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenantId"
    }],
    "kind": "Fragment",
    "metadata": {
      "connection": [{
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": v0 /*: any*/
      }],

      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0 /*: any*/
        },

        "fragmentPathInResult": [],
        "operation": require('./usePaginatedMattersPaginationQuery.graphql')
      }
    },
    "name": "usePaginatedMatters_matters",
    "selections": [{
      "alias": "matters",
      "args": [{
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      }, {
        "kind": "Variable",
        "name": "limit",
        "variableName": "limit"
      }, {
        "kind": "Variable",
        "name": "page",
        "variableName": "page"
      }, {
        "kind": "Variable",
        "name": "sort",
        "variableName": "sort"
      }, {
        "kind": "Variable",
        "name": "tenantId",
        "variableName": "tenantId"
      }],
      "concreteType": "MatterConnectionType",
      "kind": "LinkedField",
      "name": "__usePaginatedMatters_matters_connection",
      "plural": false,
      "selections": [{
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "total",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "concreteType": "MatterConnectionEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [{
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "concreteType": "_Matter",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [v1 /*: any*/, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "titleText",
            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "number",
            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dueDate",
            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "insertedAt",
            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "concreteType": "_User",
            "kind": "LinkedField",
            "name": "creator",
            "plural": false,
            "selections": [v1 /*: any*/, {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "externalReference",
            "storageKey": null
          }, {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AssigneesPreview__node"
          }, {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Status__status"
          }, {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Tags_tags"
          }, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [{
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endCursor",
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasNextPage",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Query",
    "abstractKey": null
  };
}();
(node as any).hash = "c52cfb9c37629d1135c6a86701b42781";
export default node;